import type { TireInventoryFilterCountsApiData, TireInventoryListApiData } from '@navio/nsdk';
import { filterUnitFor, type SharedQuery } from 'noddi-ui-web';

type TireListQuery = NonNullable<TireInventoryListApiData['query']>;
type TireCountsQuery = NonNullable<TireInventoryFilterCountsApiData['query']>;

/** The list and its facet counts take the same filters, so a unit writes only params both accept. */
export type TireInventoryFilterInput = SharedQuery<TireListQuery, TireCountsQuery>;

export const tireInventoryFilterUnit = filterUnitFor<TireInventoryFilterInput>();
